module.exports = __webpack_public_path__ + "static/media/bg-section-02.e64bdd19.png";